export default __webpack_public_path__ + "static/media/Sculpture-small.4a3f4099.jpeg";